// 假设你的应用版本存储在 package.json 中
const packageVersion = require('../../package.json').version;
 
function initApp() {
  const storedVersion = localStorage.getItem('appVersionByHippoWeb');
  if (storedVersion !== packageVersion) {
    // 版本不同，清空localStorage并更新版本号
    localStorage.clear();
    localStorage.setItem('appVersionByHippoWeb', packageVersion);
  }
}
 
initApp();